import { render, staticRenderFns } from "./People.vue?vue&type=template&id=18d5aab4&scoped=true&"
import script from "./People.vue?vue&type=script&lang=js&"
export * from "./People.vue?vue&type=script&lang=js&"
import style0 from "./People.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./People.vue?vue&type=style&index=1&id=18d5aab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d5aab4",
  null
  
)

export default component.exports